import { css } from '@bts-web/utils-style-engine';
import { FC, ReactNode, ComponentProps } from 'react';
import { motion } from 'framer-motion';

interface ITransfersLayoutProps {
  topRegion?: ReactNode;
  visual?: 'default' | 'neutral';
  middleScrollableRegion?: ReactNode;
  wrapperProps?: ComponentProps<typeof motion.div>;
}

const TransfersLayout: FC<ITransfersLayoutProps> = ({
  topRegion,
  middleScrollableRegion,
  visual = 'default',
  wrapperProps,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0.5 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.35 }}
      className={css({
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flex: 1,
        backgroundColor: 'screen_background.primary',
        ...(visual === 'default' || !visual
          ? {}
          : { backgroundColor: 'neutrals.fill_quaternary' }),
      })}
      {...wrapperProps}
    >
      {topRegion && <div className={css({})}>{topRegion}</div>}

      {middleScrollableRegion && (
        <div
          data-testid="middle-scrollable-region"
          className={css({
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            ...(visual === 'default' || !visual ? { px: 'medium' } : {}),
          })}
        >
          {middleScrollableRegion}
        </div>
      )}
    </motion.div>
  );
};

export { TransfersLayout };
